import React from 'react';
import { View, StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import { getAvatarUrl } from '../../utils/Functions';
import { CachedImage } from '../../components';
import { FontAwesome, Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';

const UserAvatar = (props) => {
  // props
    // userId - required
    // avatar -  required
    // size - optional
    // borderColor - optional

  const ref = React.useRef(null);

  React.useEffect(() => {
    if(props.verified){
      ref.current.setNativeProps({ title: props.verified === 'Verified' ? 'Verified Account' : 'Unverified Account' });
    }
  }, [props.verified])

  const borderColor = props.borderColor || Colors.lightBlue2;
  const size = props.size || 'large';
  const sizes = {
    xlarge: 180,
    large: 120,
    medium: 80,
    small: 40,
  }
  const shieldSizes1 = {
    xlarge: 54,
    large: 44,
    medium: 32,
    small: 14,
  }
  const shieldSizes2 = {
    xlarge: 48,
    large: 40,
    medium: 28,
    small: 12,
  }
  const shieldSizes3 = {
    xlarge: 30,
    large: 24,
    medium: 18,
    small: 8,
  }
  const avatarSize = () => {
    return {
      width: sizes[size],
      height: sizes[size],
      borderRadius: 100,
    }
  }
  const borderStyle = () => {
    let borderWidth = 5;
    switch(size){
      case 'xlarge':
      case 'large':
        borderWidth = 5;
        break;
      case 'medium':
        borderWidth = 3;
        break;
      case 'small':
        borderWidth = 1;
        break;
      default:
        borderWidth = 5;
        break;
    }
    return {
      borderWidth: borderWidth,
      borderColor: borderColor,
    }
  }
  const shieldContainerStyle = () => {
    let style = {};
    switch (size) {
      case 'xlarge':
        style = {
          position: 'absolute',
          bottom: 3,
          right: 3,
        }
        break;
      case 'large':
        style = {
          position: 'absolute',
          bottom: 1,
          right: 1,
        }
        break;
      case 'medium':
        style = {
          position: 'absolute',
          bottom: -2,
          right: -2,
        }
        break;
      case 'small':
        style = {
          position: 'absolute',
          bottom: 0,
          right: 0,
        }
        break;
      default:
        style = {
          position: 'absolute',
          bottom: 5,
          right: 5,
        }
        break;
    }
    return style;
  }
  const shieldStyle = () => {
    let style = {};
    switch (size) {
      case 'xlarge':
        style = {
          position: 'absolute',
          top: 3,
          left: 3,
        }
        break;
      case 'large':
        style = {
          position: 'absolute',
          top: 2,
          left: 2,
        }
        break;
      case 'medium':
        style = {
          position: 'absolute',
          top: 2,
          left: 2,
        }
        break;
      case 'small':
        style = {
          position: 'absolute',
          top: 1,
          left: 1,
        }
        break;
      default:
        style = {
          position: 'absolute',
          top: 3,
          left: 3,
        }
        break;
    }
    return style;
  }
  return (
    <View style={styles.outerContainer}>
      <View style={[styles.avatarContainer, borderStyle()]}>
        {props.avatar ?
          <CachedImage source={{ uri: getAvatarUrl(props.userId, props.avatar) }} style={avatarSize()} />
          :
          <FontAwesome name="user-circle-o" size={sizes[size]} color={Colors.lightGrey} />
        }
      </View>
      {props.verified &&
        <View style={shieldContainerStyle()} ref={ref}>
          <Ionicons name="shield" size={shieldSizes1[size]} color={Colors.white} />
          {props.verified === 'Verified' ?
            <Ionicons name="shield-checkmark" size={shieldSizes2[size]} color={Colors.green} style={shieldStyle()} />
            :
            <View style={[shieldStyle(), { alignItems: 'center', justifyContent: 'center'}]}>
              <Ionicons name="ios-shield-sharp" size={shieldSizes2[size]} color={Colors.red} />
              <Ionicons name="close" size={shieldSizes3[size]} color="white" style={{ position: 'absolute' }} />
            </View>
          }
        </View>
      }
    </View>
  )
}

const styles = StyleSheet.create({
  outerContainer: {
    // backgroundColor: 'red'
  },
  avatarContainer: {
    borderRadius: 100,
    overflow: 'hidden',
    // borderStyle: 'solid',
    // borderWidth: 5,
    // borderColor: borderColor,
  },
})

export default UserAvatar;